import type { MoneyAutomationCountryFeatureConfig } from './type';

export const moneyAutomationFeatureConfigCZ: MoneyAutomationCountryFeatureConfig = {
    roundUpSavings: {
        signingEndpoint: 'auths-sign/auth/operation/sign/',
        localStoreProductUri: '?product_id=SCS',
        useClientIdWithUnderscore: false,
    },
};
